

















    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import appconst from '@/lib/appconst';
    import PageRequest from '@/store/entities/page-request'
    import Enums from '@/lib/enums'

    class PagefrontthirdpartyRequest extends PageRequest {
        stockProductInfoId: number;
    }
    @Component
    export default class LookmodelModule extends AbpBase {
        editModalShow: boolean = false;
        supplyModalShow: boolean = false;
        pagerequest: PagefrontthirdpartyRequest = new PagefrontthirdpartyRequest();
        IsCheckedStatus = Enums.getEnum(Enums.IsCheckStatus, true);
        creationTime: Date[] = [];
        createModalShow: boolean = false;
        deleteData: boolean = false;

        @Prop({ type: Boolean, default: false }) value: boolean;
        selectDate: string = "";
        selectDates: string = "";
        addLoding = false;
        siteType = Enums.SiteSType;
        whetherLocalList = Enums.WhetherLocal;
        amountTotal: string = '';;
        isShow: boolean;
        get list() {
            return this.$store.state.frontthirdparty.list;
        };
        get loading() {
            return this.$store.state.frontthirdparty.loading;
        }
        cancel() {
            (this.$refs.skuForm as any).resetFields();
            this.$emit('input', false);
        }
        pageChange(page: number) {
            this.$store.commit('frontthirdparty/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('frontthirdparty/setPageSize', pagesize);
            this.getpage();
        }
        async searchPage() {
            this.$store.state.user.currentPage = 1;
            this.getpage();
        }
        async deleteskudata(data: any) {
            await this.$store.dispatch({
                type: 'frontthirdparty/delData',
                data: {id:data.id}
            })
            this.getpage();
        }
        async getpage() {

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            this.pagerequest.stockProductInfoId = this.$store.state.frontstockproduct.id;
            await this.$store.dispatch({
                type: 'frontthirdparty/getAll',
                data: this.pagerequest
            })

        }
        get pageSize() {
            return this.$store.state.frontthirdparty.pageSize;
        }
        get totalCount() {
            return this.$store.state.frontthirdparty.totalCount;
        }
        get currentPage() {
            return this.$store.state.frontthirdparty.currentPage;
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                this.getpage();
                //var b = this.$store.state.frontstockproduct.id;
                //alert(b);
                //this.$set(this.pagerequest, "id", this.$store.state.frontstockproduct.id);
            }
        }
        async created() {

           
        }
        columns = [
            {
                title: '第三方平台SKU',
                key: 'thirdPartySku',
                width: 220,
            },
            {
                title: '商家产品SKU',
                key: 'productSku',
                width: 140,
            },
            {
                title: '操作',
                key: '',
                width: 120,
                render: (h: any, params: any) => {
                    return h('Button', {
                        on: { click: () => { this.deleteskudata(params.row) } }, props: {
                            type: 'error',
                            size: 'small',
                        },
                        style: {
                            width: '60px',
                            height: '30px',
                            display: params.row.isCheckBy == null ? "inline-block" : "none",

                        } }, "删除");
                }
            }
        ]
    }


